import React from 'react';
import SideNavItem from 'factory/sidenav/components/SideNavItem';
import { flowRight as compose } from 'lodash';
import Auth, { ClientAddon } from 'Auth';
import { changeAddon, ChangeAddon } from 'factory/login/sessionReducer';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { useNavigate } from 'react-router-dom';

interface StateProps {}

interface DispatchProps {
  changeAddon: ChangeAddon;
}

export interface AddonsSideNavItemProps {}

type Props = StateProps & DispatchProps & WrappedComponentProps & AddonsSideNavItemProps;

const AddonsSideNavItem: React.FC<Props> = ({ changeAddon, intl }) => {
  const navigate = useNavigate();

  const changeAddonHandler = (addonId: number) => {
    changeAddon(addonId, navigate, '/');
  };

  const sortClientAddons = (a: ClientAddon, b: ClientAddon) =>
    intl.formatMessage({ id: a.addon.keyword }) >
    intl.formatMessage({ id: b.addon.keyword })
      ? 1
      : -1;

  const clientAddons = Auth.isUserAuthenticated()
    ? Auth.getJWT().clientAddons!.sort(sortClientAddons)
    : [];
  const addon = Auth.isUserAuthenticated() ? Auth.getJWT().addonKeyword! : '';

  return (
    <SideNavItem
      sublabel={addon}
      submenuIcon="Dots"
      submenuLabel="addons"
      icon="Dots"
      label="addons"
    >
      <ul className="navigation">
        {clientAddons.map((clientAddon: ClientAddon, index: number) => (
          <SideNavItem
            key={index}
            icon="view_module"
            description={clientAddon.addon.keyword + '.description'}
            active={clientAddon.addon.keyword === addon}
            label={clientAddon.addon.keyword}
            onClick={() => changeAddonHandler(clientAddon.addon.id)}
          />
        ))}
      </ul>
    </SideNavItem>
  );
};

const mapDispatchToProps = (dispatch): DispatchProps =>
  bindActionCreators({ changeAddon }, dispatch);

export default compose(
  connect(null, mapDispatchToProps),
  injectIntl
)(AddonsSideNavItem);
